"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BannersSection = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutOfferHints = require("@ori/checkout-offer-hints");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _MerchandisingItem = require("./MerchandisingItem");
var _ReferralVoucher = require("./ReferralVoucher");
var _RewardShopBanner = require("./RewardShopBanner");
var _jsxRuntime = require("react/jsx-runtime");
const BannerWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'grid',
        gridTemplateColumns: '100%',
        justifyContent: 'stretch',
        gap: 10,
        padding: theme.spacing(0, 3),
        '@media (min-width: 768px)': {
            padding: 0
        }
    };
});
const BannersSection = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { basketOffers, message, showBannerSection, vipLoyalty, vouchers } = (0, _contexts.useBasketContext)();
    const { isDoubleCurrency } = (0, _contexts.useCheckoutBasket)();
    if (!showBannerSection) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BannerWrapper, {
        children: [
            vipLoyalty ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_RewardShopBanner.RewardShopBanner, {
                "data-testid": getTestId('reward-shop-banner'),
                rewardShopBanner: vipLoyalty
            }) : null,
            basketOffers.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutOfferHints.App, {
                isDoubleCurrency: isDoubleCurrency
            }) : null,
            vouchers.map((unit)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_ReferralVoucher.ReferralVoucher, {
                    "data-testid": getTestId("referral-voucher-".concat(unit.voucherCode)),
                    voucherUnit: unit
                }, unit.voucherCode)),
            message ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_MerchandisingItem.MerchandizingItem, {
                "data-testid": getTestId('wp-shopping-message'),
                ...message
            }) : null
        ]
    });
};
exports.BannersSection = BannersSection;
